<template>
  <div>
    <el-row>
      <el-col :span="10">
        <span>单位配置：</span>
        <span>请选择您要使用的计量单位：</span>
        <el-radio v-model="radio" label="1">KG</el-radio>
        <el-radio v-model="radio" label="0">斤</el-radio>
      </el-col>
      <el-col :span="4">
        <el-button size="small" @click="submit">提交</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="10">
        <span>销售转采购策略：</span>
        <span>请选择您要使用的策略：</span>
        <el-select filterable v-model="setTwo" placeholder="请选择" :clearable="true">
          <el-option v-for="item in twoSetList" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-button size="small" @click="submitTwo">提交</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="10">
        <span>录入同一客户订单是否合并：</span>
        <el-radio v-model="addRadio" label="1">是</el-radio>
        <el-radio v-model="addRadio" label="0">否</el-radio>
      </el-col>
      <el-col :span="4">
        <el-button size="small" @click="submitAddOrder">提交</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="10">
        <span>库存展示使用分类：</span>
        <el-radio v-model="wareKindRadio" label="1">默认分类</el-radio>
        <el-radio v-model="wareKindRadio" label="0">自有分类</el-radio>
      </el-col>
      <el-col :span="4">
        <el-button size="small" @click="submitEditWareKind">提交</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="10">
        <span>采购移动商品是否生成新订单：</span>
        <el-radio v-model="shopOrderRadio" label="1">是</el-radio>
        <el-radio v-model="shopOrderRadio" label="0">否</el-radio>
      </el-col>
      <el-col :span="4">
        <el-button size="small" @click="submitShopOrder">提交</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="10">
        <span>导出商品名称显示：</span>
        <el-radio v-model="productNameRadio" label="0">长名称</el-radio>
        <el-radio v-model="productNameRadio" label="1">短名称</el-radio>
      </el-col>
      <el-col :span="4">
        <el-button size="small" @click="submitProductName">提交</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="10">
        <span>页面数量：</span>
        <el-input style="width:200px;" v-model="pageCount" placeholder="请输入页面条目数量"></el-input>
      </el-col>
      <el-col :span="4">
        <el-button size="small" @click="submitPageCount">提交</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="10">
        <span>价格记忆分类：</span>
        <el-radio v-model="memoryPrices" label="0">订单价格</el-radio>
        <el-radio v-model="memoryPrices" label="1">在供产品价格</el-radio>
      </el-col>
      <el-col :span="4">
        <el-button size="small" @click="submitMemoryPrices">提交</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="10">
        <span>是否需要设置可入库产品：</span>
        <el-radio v-model="setStorage" label="0">否</el-radio>
        <el-radio v-model="setStorage" label="1">是</el-radio>
      </el-col>
      <el-col :span="4">
        <el-button size="small" @click="submitSetStorage">提交</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="10">
        <span>可报价时间配置：</span>
        <el-checkbox-group ref="offerTimeForm" v-model="offerTimeForm" @change="boxChange">
          <el-checkbox label="1">周一</el-checkbox>
          <el-checkbox label="2">周二</el-checkbox>
          <el-checkbox label="3">周三</el-checkbox>
          <el-checkbox label="4">周四</el-checkbox>
          <el-checkbox label="5">周五</el-checkbox>
          <el-checkbox label="6">周六</el-checkbox>
          <el-checkbox label="7">周日</el-checkbox>
        </el-checkbox-group>
      </el-col>
      <el-col :span="4">
        <el-button size="small" @click="submitOfferTime">提交</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="10">
        <span>多人操作同一订单提醒：</span>
        <el-switch v-model="canEveryoneModify" active-text="是" inactive-text="否">
        </el-switch>
      </el-col>
      <el-col :span="4">
        <el-button size="small" @click="setMultiplePeopleWarning">提交</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="10">
        <span>出库是否自动拆箱：</span>
        <el-switch v-model="canAutomaticUnpacking" active-text="是" inactive-text="否">
        </el-switch>
      </el-col>
      <el-col :span="4">
        <el-button size="small" @click="setCanAutomaticUnpacking">提交</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="10">
        <span style="display: block;">送货数量设置：</span>
        <el-radio v-model="setDeliveryNum" label="0">手工填写(现状即为手工填写，在销售订单中逐个填写/更新)</el-radio>
        <el-radio v-model="setDeliveryNum" label="1">同步出库数量(销售订单出库后，将出库数量设置为送货数量)</el-radio>
      </el-col>
      <el-col :span="4">
        <el-button size="small" @click="submitsetDeliveryNum">提交</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="10">
        <span>销售订单录入同一产品是否合并：</span>
        <el-switch v-model="canSalesOrderMergeSameProduct" active-text="是" inactive-text="否">
        </el-switch>
      </el-col>
      <el-col :span="4">
        <el-button size="small" @click="setCanSalesOrderMergeSameProduct">提交</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="10">
        <span>销售订单没有转采购能否一键转换待确认：</span>
        <el-switch v-model="CONVERT_TO_BE_CONFIRMED" active-text="是" inactive-text="否">
        </el-switch>
      </el-col>
      <el-col :span="4">
        <el-button size="small" @click="setConvertToBeConfirmed">提交</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="10">
        <span>发起后的销售订单是否允许调整：</span>
        <el-radio v-model="isChangeRadio" label="1">是</el-radio>
        <el-radio v-model="isChangeRadio" label="0">否</el-radio>
      </el-col>
      <el-col :span="4">
        <el-button size="small" @click="submitIsChange">提交</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="10">
        <span>销售订单录入产品来源：</span>
        <el-radio v-model="PRODUCT_SOURCE" :label="0">常用SKU</el-radio>
        <el-radio v-model="PRODUCT_SOURCE" :label="1">在供产品</el-radio>
      </el-col>
      <el-col :span="4">
        <el-button size="small" @click="submitSalesOrderProductSource">提交</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="10">
        <span>销售订单待送订单导出PDF是否转换订单状态:</span>
        <el-radio v-model="CHANGE_ORDER_STATUS" :label="0">否</el-radio>
        <el-radio v-model="CHANGE_ORDER_STATUS" :label="1">是</el-radio>
      </el-col>
      <el-col :span="4">
        <el-button size="small" @click="submitChangeOrder">提交</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="10">
        <span>没有采购价是否允许上架产品：</span>
        <el-switch v-model="NO_PURCHASE_PRICE_SHELVES" active-text="是" inactive-text="否">
        </el-switch>
      </el-col>
      <el-col :span="4">
        <el-button size="small" @click="submitNoPurchasePriceShelves">提交</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="10">
        <span>销售转采购应急供应商是否必须有采购价格：</span>
        <el-radio v-model="PURCHASE_PRICE" :label="0">否</el-radio>
        <el-radio v-model="PURCHASE_PRICE" :label="1">是</el-radio>
      </el-col>
      <el-col :span="4">
        <el-button size="small" @click="submitPurchasePrice">提交</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="10">
        <span>对标价网站配置：</span>
        <el-select filterable v-model="selectedWebsite" placeholder="请选择" :clearable="true">
          <el-option v-for="item in websiteList" :key="item.WEBSITE_ID" :label="item.NAME" :value="item.WEBSITE_ID">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-button size="small" @click="submitWebsite">设置</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="10">
        <span>采购订单是否允许录入相同产品：</span>
        <el-radio v-model="isPurchaseSameProduct" :label="0">否</el-radio>
        <el-radio v-model="isPurchaseSameProduct" :label="1">是</el-radio>
      </el-col>
      <el-col :span="4">
        <el-button size="small" @click="submitPurchaseSameProduct">提交</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="10">
        <span>销售录单是否校验重复备注：</span>
        <el-radio v-model="IS_SIMILIAR_ORDER" :label="0">否</el-radio>
        <el-radio v-model="IS_SIMILIAR_ORDER" :label="1">是</el-radio>
      </el-col>
      <el-col :span="4">
        <el-button size="small" @click="submitIsSimiliarOrder">提交</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="10">
        <span>销售订单转采购是否过滤第三方供应商：</span>
        <el-radio v-model="DOES_TRANSFER_SALES_TO_PURCHASES_EXCLUDE_THIRD_PARTY_SUPPLIER" :label="0">否</el-radio>
        <el-radio v-model="DOES_TRANSFER_SALES_TO_PURCHASES_EXCLUDE_THIRD_PARTY_SUPPLIER" :label="1">是</el-radio>
      </el-col>
      <el-col :span="4">
        <el-button size="small" @click="updateDoesTransferSalesToPurchasesExcludeThirdPartySupplier">提交</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="10">
        <span>库存是否展示产品温区：</span>
        <el-radio v-model="IS_STOCK_LIST_SHOW_TEMPERATURE_ZONE" :label="0">否</el-radio>
        <el-radio v-model="IS_STOCK_LIST_SHOW_TEMPERATURE_ZONE" :label="1">是</el-radio>
      </el-col>
      <el-col :span="4">
        <el-button size="small" @click="updateIsStockListShowTemperatureZone">提交</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="10">
        <span>销售订单详情展示顺序：</span>
        <el-radio-group v-model="ORDER_BY_ORDER_LIST">
          <el-radio :label="0">按SKU编码顺序</el-radio>
          <el-radio :label="1">按录入顺序</el-radio>
        </el-radio-group>
      </el-col>
      <el-col :span="4">
        <el-button size="small" @click="setSalesOrderSortingMethod">提交</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="10">
        <span>导出合并PDF时未填送货数量是否展示为订购数量：</span>
        <el-radio v-model="FILL_EMPTY_NEED_COUNT" :label="0">否</el-radio>
        <el-radio v-model="FILL_EMPTY_NEED_COUNT" :label="1">是</el-radio>
      </el-col>
      <el-col :span="4">
        <el-button size="small" @click="submitFillEmptyNeedCount">提交</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="10">
        <span>下单/出库环节单位来源：</span><br>
        <el-radio v-model="orderOutboundUnitMode" label="0">使用自身单位配置</el-radio>
        <el-radio v-model="orderOutboundUnitMode" label="1">使用团餐客户单位设置</el-radio>
      </el-col>
      <el-col :span="4">
        <el-button size="small" @click="submitOrderOutboundUnitMode">提交</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="10">
        <span>非模板打印抬头供应商名称：</span>
        <el-radio v-model="printHeaderSupplierSource" :label="0">订单中的供应商名称</el-radio>
        <el-radio v-model="printHeaderSupplierSource" :label="1">当前登录账号所属供应商名称</el-radio>
      </el-col>
      <el-col :span="4">
        <el-button size="small" @click="submitPrintHeaderSupplierSource">提交</el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  unitManageFun, setOfferTime, querytOfferTime, updateSupplierSetting, getSupplierConfig,
} from 'api/systemSetting';
import http from '../../assets/common/http';

export default {
  data () {
    return {
      setDeliveryNum: '0',
      setStorage: '0',
      memoryPrices: '1',
      productNameRadio: '1',
      radio: '1',
      setTwo: '0',
      twoSetList: [
        {
          ID: '0',
          NAME: '缺省配置',
        },
        {
          ID: '1',
          NAME: '手动指定',
        },
      ],
      addRadio: '1',
      isChangeRadio: '1',
      wareKindRadio: '1',
      shopOrderRadio: '1',
      pageCount: '',
      // 报价时间配置
      offerTimeForm: [],
      canEveryoneModify: '',
      canAutomaticUnpacking: '',
      canSalesOrderMergeSameProduct: '',
      CONVERT_TO_BE_CONFIRMED: '',
      PRODUCT_SOURCE: '',
      CHANGE_ORDER_STATUS: '',
      NO_PURCHASE_PRICE_SHELVES: '',
      PURCHASE_PRICE: 0,
      selectedWebsite: '',
      websiteList: [],
      isPurchaseSameProduct: null,
      IS_SIMILIAR_ORDER: 0,
      DOES_TRANSFER_SALES_TO_PURCHASES_EXCLUDE_THIRD_PARTY_SUPPLIER: null,
      IS_STOCK_LIST_SHOW_TEMPERATURE_ZONE: '',
      ORDER_BY_ORDER_LIST: 0,
      FILL_EMPTY_NEED_COUNT: 0,
      orderOutboundUnitMode: '0',
      printHeaderSupplierSource: 1,
    };
  },
  methods: {
    // 统一更新设置：调用 updateSupplierSetting → 成功提示 → 刷新 session → 错误提示
    updateSetting (params, successMsg = '修改成功') {
      return updateSupplierSetting(params).then((res) => {
        this.$message.show({ text: successMsg, type: 'success' });
        this.refreshSupplierConfig();
        return res;
      }).catch((e) => {
        this.$message.show({ text: e, type: 'error' });
        throw e;
      });
    },
    // 分页方法
    submitPageCount () {
      if (this.pageCount && (this.pageCount > 0) && !Number.isNaN(Number(this.pageCount)) && (Number(this.pageCount) % 1 === 0)) {
        if (this.pageCount > this.$util.每页条数最大值) {
          this.$message.show({ text: '页面条数最多不可以超过500', type: 'warning' });
          return false;
        }
        localStorage.setItem('SMP_PAGE_COUNT', Number(this.pageCount));
        this.$message.show({ text: '提交成功', type: 'success' });
      } else {
        this.$message.show({ text: '请输入正确的整数', type: 'warning' });
      }
    },
    submitSetStorage () {
      this.updateSetting({ USE_IW_PRODUCT_CODE: Number(this.setStorage) })
        .then(() => { this.queryTypeUnit(); });
    },
    // ----------------------------提交价格类型
    submitMemoryPrices () {
      this.updateSetting({ USE_SUPPLIER_PRICE: Number(this.memoryPrices) })
        .then(() => { this.queryTypeUnit(); });
    },
    // ----------------------------修改长短名称
    submitProductName () {
      this.updateSetting({ IS_SHORT_NAME: this.productNameRadio })
        .then(() => { this.queryTypeUnit(); });
    },
    // -------------------------------修改
    submit () {
      if (document.body.style.cursor === 'wait') return;
      document.body.style.cursor = 'wait';
      this.updateSetting({ USE_KG: this.radio })
        .then(() => { sessionStorage.setItem('IS_USE_KG', this.radio); })
        .finally(() => { document.body.style.cursor = 'default'; });
    },
    // 下单/出库环节单位来源
    submitOrderOutboundUnitMode () {
      this.updateSetting({ ORDER_OUTBOUND_UNIT_MODE: Number(this.orderOutboundUnitMode) })
        .then(() => { this.queryTypeUnit(); });
    },
    // ----------------------------------获取当前使用的单位
    queryTypeUnit () {
      unitManageFun().then((result) => {
        this.radio = result[0].USE_KG.toString();
        this.setTwo = result[0].SALE_TO_PURCHASE_POLICY.toString();
        this.addRadio = result[0].IS_MERGE_ORDER.toString();
        this.wareKindRadio = result[0].STOCK_DEFAULT_CATALOG.toString();
        this.shopOrderRadio = result[0].Purchase_New_Order_Tag.toString();
        this.productNameRadio = result[0].IS_SHORT_NAME.toString();
        this.memoryPrices = result[0].USE_SUPPLIER_PRICE.toString();
        this.setStorage = result[0].USE_IW_PRODUCT_CODE.toString();
        this.isChangeRadio = result[0].ORDER_ADJUST.toString();
        this.canEveryoneModify = result[0].CAN_EVERYONE_MODIFY.toString() == '0';
        this.canAutomaticUnpacking = result[0].CAN_AUTOMATIC_UNPACKING == 1;
        this.setDeliveryNum = result[0].CONFIG_OF_DELIVERY.toString();
        this.canSalesOrderMergeSameProduct = result[0].IS_MERGE_SAME_PRODUCT == 1;
        this.CONVERT_TO_BE_CONFIRMED = result[0].CONVERT_TO_BE_CONFIRMED == 1;
        this.PRODUCT_SOURCE = result[0].PRODUCT_SOURCE;
        this.CHANGE_ORDER_STATUS = result[0].CHANGE_ORDER_STATUS;
        this.NO_PURCHASE_PRICE_SHELVES = !result[0].NO_PURCHASE_PRICE_SHELVES;
        this.PURCHASE_PRICE = result[0].CONVERT_PURCHASE_PRICE;
        this.selectedWebsite = result[0].COMPARE_WEBSITE_ID ? result[0].COMPARE_WEBSITE_ID : '';
        this.isPurchaseSameProduct = result[0].IS_PURCHASE_SAME_PRODUCT;
        this.IS_SIMILIAR_ORDER = result[0].IS_SIMILIAR_ORDER;
        this.DOES_TRANSFER_SALES_TO_PURCHASES_EXCLUDE_THIRD_PARTY_SUPPLIER = result[0].DOES_TRANSFER_SALES_TO_PURCHASES_EXCLUDE_THIRD_PARTY_SUPPLIER;
        this.IS_STOCK_LIST_SHOW_TEMPERATURE_ZONE = result[0].IS_STOCK_LIST_SHOW_TEMPERATURE_ZONE;
        this.ORDER_BY_ORDER_LIST = result[0].ORDER_BY_ORDER_LIST;
        this.orderOutboundUnitMode = (result[0].ORDER_OUTBOUND_UNIT_MODE !== undefined ? result[0].ORDER_OUTBOUND_UNIT_MODE : 0).toString();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 设置策略
    submitTwo () {
      if (document.body.style.cursor === 'wait') return;
      document.body.style.cursor = 'wait';
      this.updateSetting({ SALE_TO_PURCHASE_POLICY: this.setTwo })
        .then(() => { this.queryTypeUnit(); })
        .finally(() => { document.body.style.cursor = 'default'; });
    },
    // 设置订单是否合并
    submitAddOrder () {
      this.updateSetting({ IS_MERGE_ORDER: this.addRadio })
        .then(() => { this.queryTypeUnit(); });
    },
    // 发起订单是否允许调整
    submitIsChange () {
      this.updateSetting({ ORDER_ADJUST: this.isChangeRadio });
    },
    submitIsSimiliarOrder () {
      this.updateSetting({ IS_SIMILIAR_ORDER: this.IS_SIMILIAR_ORDER });
    },
    // 设置库存展示需要自有分类还是系统默认分类
    submitEditWareKind () {
      this.updateSetting({ STOCK_DEFAULT_CATALOG: this.wareKindRadio })
        .then(() => { this.queryTypeUnit(); });
    },
    // 设置采购订单是否生成新订单
    submitShopOrder () {
      this.updateSetting({ Purchase_New_Order_Tag: this.shopOrderRadio })
        .then(() => { this.queryTypeUnit(); });
    },
    // 获取现在报价时间
    querytOfferTime () {
      querytOfferTime().then((result) => {
        if (result.length != 0) {
          const str = result.join(',');
          const arr = str.split(',');
          this.offerTimeForm = arr;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    boxChange () {
    },
    // 提交报价时间
    submitOfferTime () {
      const params = {
        QUOTE_DAYS: this.offerTimeForm,
      };
      setOfferTime(params).then((result) => {
        this.$message.show({ text: '配置成功', type: 'success' });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 多人操作同一订单提醒
    setMultiplePeopleWarning () {
      this.updateSetting({ CAN_EVERYONE_MODIFY: this.canEveryoneModify ? 0 : 1 });
    },

    // 出库是否自动拆箱
    setCanAutomaticUnpacking () {
      this.updateSetting({ CAN_AUTOMATIC_UNPACKING: this.canAutomaticUnpacking ? 1 : 0 });
    },
    // 送货数量配置
    submitsetDeliveryNum () {
      this.updateSetting({ CONFIG_OF_DELIVERY: this.setDeliveryNum });
    },
    // 设置销售订单录入同一产品是否合并
    setCanSalesOrderMergeSameProduct () {
      this.updateSetting({ IS_MERGE_SAME_PRODUCT: this.canSalesOrderMergeSameProduct ? 1 : 0 });
    },
    // 销售订单没有转采购能否一键转换待确认
    setConvertToBeConfirmed () {
      this.updateSetting({ CONVERT_TO_BE_CONFIRMED: this.CONVERT_TO_BE_CONFIRMED ? 1 : 2 });
    },
    submitSalesOrderProductSource () {
      this.updateSetting({ PRODUCT_SOURCE: this.PRODUCT_SOURCE });
    },
    submitChangeOrder () {
      this.updateSetting({ CHANGE_ORDER_STATUS: this.CHANGE_ORDER_STATUS });
    },
    submitNoPurchasePriceShelves () {
      this.updateSetting({ NO_PURCHASE_PRICE_SHELVES: Number(!this.NO_PURCHASE_PRICE_SHELVES) });
    },
    submitPurchasePrice () {
      this.updateSetting({ CONVERT_PURCHASE_PRICE: this.PURCHASE_PRICE }, '设置成功');
    },
    // 获取对标价格网站列表
    getWebsiteList () {
      const params = {
        SERVICE_ID: '15068',
        OTYPE: 41,
        GYS_ID: sessionStorage.getItem('tcId'),
      };
      http.post(params).then((res) => {
        this.websiteList = res;
      }).catch((e) => {
        this.$message.show({ text: e, type: 'error' });
      });
    },
    // 设置对标价格网站
    submitWebsite () {
      const params = {
        SERVICE_ID: '10051',
        OTYPE: 10,
        GYS_ID: sessionStorage.getItem('tcId'),
        COMPARE_WEBSITE_ID: this.selectedWebsite,
      };
      http.post(params).then((res) => {
        this.$message.show({ text: '设置成功', type: 'success' });
      }).catch((e) => {
        this.$message.show({ text: e, type: 'error' });
      });
    },
    submitPurchaseSameProduct () {
      this.updateSetting({ IS_PURCHASE_SAME_PRODUCT: this.isPurchaseSameProduct }, '设置成功');
    },
    updateDoesTransferSalesToPurchasesExcludeThirdPartySupplier () {
      this.updateSetting({ DOES_TRANSFER_SALES_TO_PURCHASES_EXCLUDE_THIRD_PARTY_SUPPLIER: this.DOES_TRANSFER_SALES_TO_PURCHASES_EXCLUDE_THIRD_PARTY_SUPPLIER }, '设置成功');
    },
    updateIsStockListShowTemperatureZone () {
      this.updateSetting({ IS_STOCK_LIST_SHOW_TEMPERATURE_ZONE: this.IS_STOCK_LIST_SHOW_TEMPERATURE_ZONE }, '设置成功');
    },
    setSalesOrderSortingMethod () {
      this.updateSetting({ ORDER_BY_ORDER_LIST: this.ORDER_BY_ORDER_LIST }, '设置成功');
    },
    submitFillEmptyNeedCount () {
      this.updateSetting({ FILL_EMPTY_NEED_COUNT: this.FILL_EMPTY_NEED_COUNT }, '设置成功');
    },
    // 非模板打印抬头供应商名称来源：0=订单中的供应商名称，1=当前登录账号所属供应商名称
    submitPrintHeaderSupplierSource () {
      this.updateSetting({ PRINT_HEADER_SUPPLIER_SOURCE: Number(this.printHeaderSupplierSource) }, '设置成功');
    },
    // 刷新供应商配置到sessionStorage
    refreshSupplierConfig () {
      getSupplierConfig().then((res) => {
        sessionStorage.setItem('config', JSON.stringify(res[0].list[0]));
      }).catch((err) => {
        console.log('generalSettings.vue, 10017-6', err);
      });
    },

  },
  created () {
    this.pageCount = localStorage.getItem('SMP_PAGE_COUNT') ? localStorage.getItem('SMP_PAGE_COUNT') : '';
    this.canEveryoneModify = localStorage.getItem('SMP_MULTIPLE_PEOPLE_WARNING') == '1';
    const configStr = sessionStorage.getItem('config');
    if (configStr) {
      const config = JSON.parse(configStr);
      this.FILL_EMPTY_NEED_COUNT = config.FILL_EMPTY_NEED_COUNT !== undefined ? config.FILL_EMPTY_NEED_COUNT : 0;
      this.printHeaderSupplierSource = config.PRINT_HEADER_SUPPLIER_SOURCE !== undefined ? Number(config.PRINT_HEADER_SUPPLIER_SOURCE) : 1;
    }
    this.queryTypeUnit();
    this.querytOfferTime();
    this.getWebsiteList();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/setting/generalSettings.vue